export const siteStats = [
  { label: "收录影视", value: "12,800+", unit: "部" },
  { label: "每日更新", value: "128", unit: "部/集" },
  { label: "高清资源", value: "98%", unit: "占比" },
  { label: "影视类型", value: "26", unit: "类" },
];

export const quickCategories = ["全部", "电影", "电视剧", "动漫", "综艺"];

export const genreList = [
  { name: "科幻", count: 862, description: "星际远航与未来想象", icon: "ri-planet-line" },
  { name: "悬疑", count: 1240, description: "层层反转的推理叙事", icon: "ri-spy-line" },
  { name: "犯罪", count: 978, description: "罪案追踪与人性较量", icon: "ri-police-car-line" },
  { name: "古装", count: 1536, description: "衣冠风华与家国江湖", icon: "ri-ancient-gate-line" },
  { name: "都市", count: 1890, description: "当代生活与情感群像", icon: "ri-building-2-line" },
  { name: "动作", count: 1120, description: "硬核打斗与极限追逐", icon: "ri-fire-line" },
  { name: "治愈", count: 743, description: "温柔日常与缓慢生长", icon: "ri-heart-3-line" },
  { name: "历史", count: 655, description: "山河岁月与人物春秋", icon: "ri-history-line" },
  { name: "冒险", count: 918, description: "荒野秘境与远行探索", icon: "ri-compass-3-line" },
  { name: "热血", count: 1102, description: "伙伴羁绊与少年成长", icon: "ri-sword-line" },
  { name: "音乐", count: 486, description: "舞台现场与旋律故事", icon: "ri-music-2-line" },
  { name: "美食", count: 372, description: "人间烟火与味觉记忆", icon: "ri-restaurant-2-line" },
];

export const guideFaqs = [
  {
    question: "星辰影院可以在线免费观看吗？",
    answer:
      "本站聚合展示的影视资源均以在线浏览的方式呈现，页面中标注了影片的类型、年份、评分与更新进度，方便你快速判断是否值得一看。具体播放可用情况以资源本身为准，本站仅做信息聚合与整理。",
  },
  {
    question: "如何更快找到想看的电影或电视剧？",
    answer:
      "你可以使用首屏或影视库中的搜索框直接输入片名，也可以先点选「电影 / 电视剧 / 动漫 / 综艺」分类标签，再配合类型与排序筛选。若只想随便逛逛，「按类型浏览」区域能让你按题材偏好快速定位。",
  },
  {
    question: "新剧和最新电影多久更新一次？",
    answer:
      "影视库中的条目会持续整理与补充，页面顶部「今日更新」快讯条会滚动展示近期上线或更新进度的作品。热播剧集通常跟随更新节奏同步刷新集数信息，你可以在「本周剧集热播」区域查看最新进度。",
  },
  {
    question: "手机和电脑上都能顺畅浏览吗？",
    answer:
      "页面采用自适应布局，桌面端与移动端均可正常浏览。手机端会自动收窄卡片与导航，列表信息也会重新排列，方便在小屏上阅读评分、简介与更新进度等关键信息。",
  },
  {
    question: "影片播放卡顿或无法打开怎么办？",
    answer:
      "可先尝试切换网络或降低播放清晰度；若仍无法打开，通常与资源自身状态有关。本站以聚合展示为主，遇到失效资源时建议换一个同类条目，或稍后回来查看是否已有新版本上线。",
  },
  {
    question: "高分榜单是怎么排出来的？",
    answer:
      "「口碑高分榜」按站内整理的综合评分从高到低排列，评分综合了题材完成度、观众讨论热度与口碑反馈，仅作为挑选参考，不代表唯一标准。你完全可以从自己的偏好出发挑选观看。",
  },
];

export const siteIntro = {
  title: "关于星辰影院",
  paragraphs: [
    "星辰影院是一个面向中文观众的影视资源聚合站点，把最新电影、热门电视剧、动漫与综艺集中整理在一处，省去在多个平台之间来回搜索的麻烦。我们更在意「能不能帮你快速做决定」，因此每一条影视信息都会尽量标注清楚类型、年份、评分、更新进度与一句到位的简介。",
    "页面结构围绕浏览习惯设计：首屏用并列卡片呈现当下值得一看的作品，中部是可按分类、类型与评分自由筛选的影视库，再往下是剧集热播、口碑榜单与按类型浏览，帮助你从「不知道看什么」过渡到「知道今晚看什么」。",
    "无论你是想追一部正在更新的新剧，还是想补一部经典老片，都可以从本站出发，找到适合自己的观看方向。",
  ],
  highlights: [
    { icon: "ri-layout-grid-line", title: "一站式聚合", text: "电影、电视剧、动漫、综艺分类清晰，浏览路径简单直接。" },
    { icon: "ri-flashlight-line", title: "更新及时", text: "热播剧集跟随更新节奏同步进度，不错过最新一集。" },
    { icon: "ri-hd-line", title: "高清优先", text: "优先整理高清资源，标注清晰度与版本信息。" },
    { icon: "ri-bar-chart-2-line", title: "评分参考", text: "综合评分与简介并重，帮你更快判断是否值得一看。" },
  ],
};